import React from 'react';
import { RouteComponentProps, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootStoreModel } from '../../redux';
import { Loading } from '../shared/loading';
import { AuthRoutes } from '../../model/enums';
import { UserPermission } from '@globaleris/ui.library';
import { Resources } from '../../model/RBAC/constants';
import { getResourcesUserPermissions } from '../../helpers/permissionsHelper';

interface AuthRouteProps {
  Component: React.FC<RouteComponentProps>;
  path?: string;
  exact?: boolean;
  resource: Resources[];
  userPermission?: UserPermission;
}

export const AuthRoute = ({
  Component,
  path = '',
  exact = false,
  resource,
  userPermission = undefined
}: AuthRouteProps): JSX.Element => {
  const profile = useSelector((state: RootStoreModel) => state.profile.user);

  const hasRole = () => {
    if (profile?.isSuperUser) {
      return true;
    }

    return resource
      .join()
      .split(',')
      .some(x =>
        profile?.roles
          .map(z => z.resources)
          .map(x => x.map(y => y.id))
          .join()
          .split(',')
          .includes(x)
      );
  };

  const hasPermission = () => {
    if (profile?.isSuperUser) {
      return true;
    }

    if (userPermission === undefined) return true;
    return getResourcesUserPermissions(resource).includes(userPermission);
  };

  return (
    <>
      {profile !== undefined ? (
        <Route
          exact={exact}
          path={path}
          render={(props: RouteComponentProps) =>
            hasRole() && hasPermission() ? (
              <Component {...props}></Component>
            ) : (
              <Redirect to={AuthRoutes.UNAUTHORIZED}></Redirect>
            )
          }
        />
      ) : (
        <Loading></Loading>
      )}
    </>
  );
};
